import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EpcotConfig, PopupsConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { CloseButtonType } from '@frontend/sports/modal/feature';
import { Store } from '@ngrx/store';

import { LineSwitcherActions } from '../actions';

@Component({
    selector: 'bs-line-switcher-dialog-header',
    templateUrl: './line-switcher-dialog-header.html',
    styleUrls: ['./line-switcher-dialog-header.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LineSwitcherDialogHeaderComponent {
    @Input() title: string;
    readonly isEpcotEnabled = this.epcotConfig.isEnabled;

    showCloseIcon = false;

    constructor(
        private store: Store,
        public sitecore: Sitecore,
        private popupsConfig: PopupsConfig,
        private epcotConfig: EpcotConfig,
    ) {
        this.showCloseIcon = this.popupsConfig.closeButtonType === CloseButtonType.Icon || !this.isEpcotEnabled;
    }

    close(): void {
        this.store.dispatch(LineSwitcherActions.cancelLineSwitcher());
    }
}
